import { Facet, Facets } from '@wam/shared';

export class AnalyticsQuery {
  readonly query: string;

  constructor(query: string) {
    this.query = query;
  }

  static fromFacets(facets: Facets): AnalyticsQuery {
    const body = Object.keys(facets)
      .map((key) => this.getParams(key, facets))
      .filter(Boolean)
      .join('&');
    return new AnalyticsQuery(body);
  }

  static fromQuery(query: AnalyticsQuery): Facets {
    const facets: Facets = {};
    const queryArray = query.query ? query.query.split('&') : [];
    queryArray.forEach((queryParam) => {
      const key = queryParam.split('=')[0];
      const value = queryParam.split('=')[1];
      facets[key] = value.split(',').map((item) => {
        const stringItem: string = decodeURIComponent(item);
        return { value: stringItem, display: stringItem.split('|')[1] ?? stringItem };
      });
    });
    return facets;
  }

  private static getParams(key, facets: Facets) {
    const paramValue = facets[key]
      .map((facet: Facet) => (facet.ignore ? '' : this.getValue(key, facet)))
      .join(',');

    if (paramValue !== '') {
      return `${key}=${paramValue}`;
    }
    return '';
  }

  private static getValue(key: string, facet: Facet) {
    let facetValue: string = facet.value;
    if (key === 'classes' && facetValue.includes('////')) {
      facetValue = facetValue.split('////')[1];
    }
    return encodeURIComponent(facetValue);
  }

  toString(): string {
    return this.query;
  }
}
